var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"movie"},[_c('div',{staticClass:"image"},[_c('router-link',{attrs:{"to":{name: 'Details', params: {id: _vm.id}}}},[_c('img',{attrs:{"src":_vm.poster_path,"alt":""}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }